export const pdfContextActionTypes = {
    SET_PDF_FILE_NAME: 'SET_PDF_FILE_NAME',
    INITIATE_PREVIEW: 'INITIATE_PREVIEW',
    FINALISE_PREVIEW: 'FINALISE_PREVIEW',
    INITIATE_DOWNLOAD: 'INITIATE_DOWNLOAD',
    FINALISE_DOWNLOAD: 'FINALISE_DOWNLOAD',
    INITIATE_SHARE: 'INITIATE_SHARE',
    FINALISE_SHARE: 'FINALISE_SHARE',
}

export function pdfReducer( state, action ) {
    let updatedState = {
        ...state,
    };

    switch ( action.type ) {
        case pdfContextActionTypes.SET_PDF_FILE_NAME:
            updatedState = {
                ...updatedState,
                pdfFileName: action.payload
            }
            break;

        case pdfContextActionTypes.INITIATE_PREVIEW:
            updatedState = {
                ...updatedState,
                isPreviewButtonClicked: true,
            }
            break;

        case pdfContextActionTypes.FINALISE_PREVIEW:
            updatedState = {
                ...updatedState,
                isPreviewButtonClicked: false,
            }
            break;

        case pdfContextActionTypes.INITIATE_DOWNLOAD:
            updatedState = {
                ...updatedState,
                isDownloadButtonClicked: true,
                pdfKey: updatedState.pdfKey + 1,
            }
            break;

        case pdfContextActionTypes.FINALISE_DOWNLOAD:
            updatedState = {
                ...updatedState,
                isDownloadButtonClicked: false,
            }
            break;

        case pdfContextActionTypes.INITIATE_SHARE:
            updatedState = {
                ...updatedState,
                isShareButtonClicked: true,
            }
            break;

        case pdfContextActionTypes.FINALISE_SHARE:
            updatedState = {
                ...updatedState,
                isShareButtonClicked: false,
            }
            break;

        default:
            throw new Error( "Unknown action: " + action.type );
    }

    return updatedState;
}
